/**
 * Formats an ID string to show first 6 characters, ellipsis, and last 4 characters.
 * Example: "f71d3077-4af1-47bb-99e5-2ff5e063df6e" -> "f71d30...df6e"
 * @param id - The ID string to format
 * @returns Formatted ID string or empty string if input is invalid
 */
export function formatId(id: string | null | undefined): string {
	if (!id || typeof id !== "string") return "";

	// Remove any hyphens or spaces for consistent formatting
	const cleanId = id.replace(/[-\s]/g, "");

	// If the cleaned ID is 10 characters or less, return as-is
	if (cleanId.length <= 10) return id;

	// Return first 6 + ellipsis + last 4
	return `${cleanId.slice(0, 6)}...${cleanId.slice(-4)}`;
}
